import { render, staticRenderFns } from "./Ordercount.vue?vue&type=template&id=449cd6f2"
import script from "./Ordercount.vue?vue&type=script&lang=js"
export * from "./Ordercount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports